import { CSSProperties } from 'react';

import { DefaultComponentProps } from '../../types';
import Flex from '../Flex';

import { ModalDescription, ModalHeaderRoot, ModalTitle } from './Modal2.styled';
import ModalCloseButton from './ModalCloseButton';

type Props = DefaultComponentProps & {
  title: string | undefined;
  description?: string;

  /**
   * @warning
   * passing this option would mean that you need to use `ModalCloseButton` or render custom one outside of `ModalHeader` component
   */
  hideCloseButton?: boolean;

  style?: CSSProperties;
};

const ModalHeader: React.FC<Props> = ({
  title,
  description,
  hideCloseButton = false,
  ...rest
}) => (
  <ModalHeaderRoot {...rest}>
    <Flex direction="column" gap="4x" width="100%">
      {title && <ModalTitle>{title}</ModalTitle>}
      {description && <ModalDescription>{description}</ModalDescription>}
    </Flex>
    {!hideCloseButton && <ModalCloseButton />}
  </ModalHeaderRoot>
);

export default ModalHeader;
